
define('ldsh!modules/page_listing/templates/tag_itemview', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p +=
((__t = ( text )) == null ? '' : __t) +
'<i class="ri-close-fill js-delete-tag"></i>\n';

}
return __p
};});

